import { render } from "./AdvancedSettings.vue?vue&type=template&id=5b252df8"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js"

import "./AdvancedSettings.vue?vue&type=style&index=0&id=5b252df8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__